require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/object/keys.js
// module id = 1159
// module chunks = 168707334958949